export default function ContentsRecos() {
  return (
    <article className="side2" id="contents"></article>
  );
}
